import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "count", "toolbar"]

  connect() {
    this.updateCount()
  }

  toggleAll(event) {
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = event.target.checked
    })
    this.updateCount()
  }

  updateCount() {
    const checkedCount = this.checkboxTargets.filter(c => c.checked).length
    this.countTarget.textContent = checkedCount
    
    if (checkedCount > 0) {
      this.toolbarTarget.classList.remove("hidden")
    } else {
      this.toolbarTarget.classList.add("hidden")
    }
  }

  get selectedIds() {
    return this.checkboxTargets.filter(c => c.checked).map(c => c.value)
  }

  // 终极修复：使用影子链接模拟点击 (Shadow Link Click)
  openModal(event) {
    event.preventDefault()
    event.stopPropagation()
    event.stopImmediatePropagation()
    
    const { url } = event.currentTarget.dataset
    const ids = this.selectedIds

    if (ids.length === 0) {
      alert("请至少选择一项")
      return
    }

    const params = new URLSearchParams()
    ids.forEach(id => params.append("ids[]", id))
    const fullUrl = `${url}?${params.toString()}`

    if (window.Turbo && typeof window.Turbo.visit === "function") {
      window.Turbo.visit(fullUrl)
    } else {
      window.location.href = fullUrl
    }
  }

  submit(event) {
    event.preventDefault()
    const { actionUrl, method, confirm: confirmMsg } = event.currentTarget.dataset
    const ids = this.selectedIds

    if (ids.length === 0) return
    if (confirmMsg && !confirm(confirmMsg)) return

    if ((method || "").toLowerCase() === "get") {
      const params = new URLSearchParams()
      ids.forEach(id => params.append("ids[]", id))
      const fullUrl = `${actionUrl}?${params.toString()}`
      if (window.Turbo && typeof window.Turbo.visit === "function") {
        window.Turbo.visit(fullUrl)
      } else {
        window.location.href = fullUrl
      }
      return
    }

    const form = document.createElement("form")
    form.method = "post"
    form.action = actionUrl
    
    if (method && method.toLowerCase() !== 'post') {
      const methodInput = document.createElement("input")
      methodInput.type = "hidden"
      methodInput.name = "_method"
      methodInput.value = method
      form.appendChild(methodInput)
    }

    const csrfToken = document.querySelector("meta[name='csrf-token']").content
    const csrfInput = document.createElement("input")
    csrfInput.type = "hidden"
    csrfInput.name = "authenticity_token"
    csrfInput.value = csrfToken
    form.appendChild(csrfInput)

    ids.forEach(id => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "ids[]"
      input.value = id
      form.appendChild(input)
    })

    document.body.appendChild(form)
    form.submit()
  }
}
